import {
    afterNextRender,
    AfterViewInit,
    Component,
    inject,
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { LocalStorageService } from "@malirang/front-share";
import { CapacitorKakaoLogin } from "@team-lepisode/capacitor-kakao-login";
import { initializeApp } from "firebase/app";
import { environment } from "../env/env";
import { IapService } from "./services/iap.service";
import { NotificationStore } from "./stores/notification.store";
import { UserStore } from "./stores/user.store";

@Component({
    standalone: true,
    imports: [RouterModule],
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent implements AfterViewInit {
    readonly localStorageService = inject(LocalStorageService);
    readonly router = inject(Router);
    readonly userStore = inject(UserStore);
    readonly iapService = inject(IapService);
    readonly notificationStore = inject(NotificationStore);

    constructor() {
        initializeApp(environment.firebase);
        afterNextRender(async () => {
            const user = await this.userStore.fetchUser();
            console.log("Fetched user:", user);
            if (user) {
                await this.notificationStore.updateFCMToken(user);
            }
            await CapacitorKakaoLogin.initialize({
                appKey: environment.kakao.appKey,
            });
        });
    }

    async ngAfterViewInit(): Promise<void> {
        if (Capacitor.isNativePlatform()) {
            // 인앱결제 초기화
            await this.iapService.initializePurchases();
        }
    }
}
